import React, { useEffect, useState } from "react";
import Table from "../../../../../core/common/dataTable/index";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { Select, Spin } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

interface designation {
  designation_id: number;
  name: string;
}

interface branchInterface {
  branch_id: number;
  name: string;
}

const SEDTeachers = () => {
  const { Option } = Select;
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const [designationDropdown, setDesignationDropdown] = useState<designation[]>(
    [],
  );
  const [branchDropdown, setBranchDropdown] = useState<branchInterface[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem("SEDTeachers_filters");
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
          branch: "",
          building_category: "",
          designation: "",
          full_name: "",
          adaption_type: "",
        };
  });
  useEffect(() => {
    localStorage.setItem("SEDTeachers_filters", JSON.stringify(filters));
  }, [filters]);
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const FILTERS = [
    { label: "SCTS", value: "1" },
    { label: "ETS", value: "2" },
  ];

  const adaption_type = [
    { label: "Class Teacher", value: "class_teacher" },
    { label: "Adoption Teacher", value: "adaption_teacher" },
    { label: "Both", value: "both" },
  ];

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // designation Dropdown
  const fetchDesignation = async () => {
    try {
      const res = await fetch(
        `${webApi}/sed/designations_dropdown_for_teachers_list/`,
        options,
      );
      const data = await res.json();
      setDesignationDropdown(data);
    } catch (err) {
      console.error(err);
    }
  };

  // Branch Dropdown
  const fetchBranches = async () => {
    try {
      const res = await fetch(
        `${webApi}/sed/branches_dropdown_for_teacher_list_filter/?building_category=${filters.building_category}`,
        options,
      );
      const data = await res.json();
      setBranchDropdown(data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchBranches();
  }, [filters.building_category]);

  useEffect(() => {
    fetchDesignation();
  }, []);

  useEffect(() => {
    if (
      !checkPermission("view_adaption_teachers_list", "teacherstudentrelation")
    ) {
      navigate(routes.crmLandingPage);
      return;
    }
    fetchData();
  }, [userPermissions, appliedFilters, currentPage, searchText, pageSize]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams({
        branch: appliedFilters.branch || "",
        building_category: appliedFilters.building_category || "",
        designation: appliedFilters.designation || "",
        full_name: searchText || "",
        adaption_type: appliedFilters.adaption_type || "",
        page: String(currentPage),
      });
      queryParams.append("page_size", String(pageSize));
      const response = await fetch(
        `${webApi}/sed/adaption_teachers_list/?${queryParams.toString()}`,
        options,
      );
      const result = await response.json();
      if (!response.ok) {
        if (result.code === "token_not_valid") {
          navigate(routes.crmLandingPage);
          return;
        }
        throw new Error(result.detail || "Failed to fetch teachers");
      }
      setData(result.results || []);
      setTotalCount(result.total_count || 0);
    } catch (error) {
      console.error("Teachers fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Reusable function to display applied filters
  const renderFilterTag = (
    value: string | null,
    filterKey: keyof typeof appliedFilters,
  ) => {
    if (!value) return null;

    return (
      <span
        style={{
          marginLeft: 8,
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <span style={{ color: "#1890ff", marginRight: 4 }}>({value})</span>

        <CloseCircleOutlined
          onClick={() => {
            const updatedFilters = {
              ...filters,
              [filterKey]: "",
            };

            setFilters(updatedFilters);
            setAppliedFilters(updatedFilters);
          }}
          style={{ color: "red", cursor: "pointer" }}
        />
      </span>
    );
  };

  const columns = [
    {
      title: (
        <span>
          Branch Category
          {renderFilterTag(
            FILTERS.find(
              (item) =>
                String(item.value) === String(appliedFilters.building_category),
            )?.label || null,
            "building_category",
          )}
        </span>
      ),
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
      dataIndex: "building_category",
      key: "building_category",
    },

    {
      title: (
        <span>
          Branch
          {renderFilterTag(
            branchDropdown.find(
              (item) =>
                String(item.branch_id) === String(appliedFilters.branch),
            )?.name || null,
            "branch",
          )}
        </span>
      ),
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
      dataIndex: "branch",
      key: "branch",
    },

    {
      title: (
        <span>
          Teacher Name
          {renderFilterTag(appliedFilters.full_name || null, "full_name")}
        </span>
      ),
      dataIndex: "full_name",
      key: "full_name",
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
    },

    {
      title: (
        <span>
          Designation
          {renderFilterTag(
            designationDropdown.find(
              (item) =>
                String(item.designation_id) ===
                String(appliedFilters.designation),
            )?.name || null,
            "designation",
          )}
        </span>
      ),
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
      dataIndex: "designation",
      key: "designation",
    },
    {
      title: (
        <span>
          Adoption Type
          {renderFilterTag(
            adaption_type.find(
              (item) =>
                String(item.value) === String(appliedFilters.adaption_type),
            )?.label || null,
            "adaption_type",
          )}
        </span>
      ),
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
      dataIndex: "adaption_type",
      key: "adaption_type",
    },
    {
      title: "No of Students",
      dataIndex: "no_of_students",
      key: "no_of_students",
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
    },

    {
      title: "No of Paid Students",
      dataIndex: "no_of_sed_paid_students",
      key: "no_of_sed_paid_students",
      render: (
        _text: any,
        record: { teacher_id: any; no_of_attempts: number },
      ) => (
        <Link to={`${routes.SEDTeacherTicket}?id=${record.teacher_id}&r1=1`}>
          {_text}
        </Link>
      ),
    },
  ];

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleApplyClick = () => {
    setAppliedFilters(filters);
    setCurrentPage(1);
    setShowFilter(false);
  };
  const handleResetClick = () => {
    const emptyFilters = {
      branch: "",
      building_category: "",
      designation: "",
      full_name: "",
      adaption_type: "",

    };
    localStorage.removeItem("SEDTeachers_filters");
    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    setSearchText("");
    setCurrentPage(1);
    setShowFilter(false);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">SED Teachers</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Teachers
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <div className="mb-2">
                   {checkPermission("add", "summercamppriority") && (
                     <Link to={routes.SummerCampAddPriorities} className="btn btn-primary">
                       <i className="ti ti-square-rounded-plus-filled me-2" />
                       Add Priority
                     </Link>
                   )}
                 </div> */}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Teachers List</h4>

              <div className="mb-1">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  Filters
                </button>
                {showFilter && (
                  <div
                    className="card mt-3 shadow-sm"
                    style={{
                      width: "500px",
                      position: "absolute",
                      right: 0,
                      zIndex: 1000,
                      borderRadius: "12px",
                    }}
                  >
                    <form>
                      {/* Header */}
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4 className="mb-0 me-auto">Filter</h4>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowFilter(false)}
                        />
                      </div>

                      {/* Body */}
                      <div className="p-3">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Building Category
                              </label>
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select Build Category"
                                value={filters.building_category || ""}
                                onChange={(value) =>
                                  setFilters({
                                    ...filters,
                                    building_category: value || "",
                                  })
                                }
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {FILTERS.map((teamLead) => (
                                  <Option
                                    key={teamLead.value}
                                    value={teamLead.value}
                                  >
                                    {teamLead.label}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          {/* <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Branch Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={filters.branch}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    branch: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div> */}

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Designations</label>
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select Designation"
                                value={filters.designation}
                                onChange={(value) =>
                                  setFilters({
                                    ...filters,
                                    designation: value,
                                  })
                                }
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {designationDropdown.map((d) => (
                                  <Option
                                    key={d.designation_id}
                                    value={d.designation_id}
                                  >
                                    {d.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Adoption Type
                              </label>
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select Adoption Type"
                                value={filters.adaption_type || ""}
                                onChange={(value) =>
                                  setFilters({
                                    ...filters,
                                    adaption_type: value || "",
                                  })
                                }
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {adaption_type.map((teamLead) => (
                                  <Option
                                    key={teamLead.value}
                                    value={teamLead.value}
                                  >
                                    {teamLead.label}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                {" "}
                                Select Brnach{" "}
                              </label>
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select Branch"
                                value={filters.branch}
                                onChange={(value) =>
                                  setFilters({
                                    ...filters,
                                    branch: value,
                                  })
                                }
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {branchDropdown.map((d) => (
                                  <Option key={d.branch_id} value={d.branch_id}>
                                    {d.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div className="p-3 border-top d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light me-3"
                          onClick={handleResetClick}
                        >
                          Reset
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={data}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "25", "100", "500", "1000"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
    </div>
  );
};

export default SEDTeachers;
